module.exports = __webpack_public_path__ + "img/ifoodLogo.1dc4d57d.png";